import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context3, _context4; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context3 = ownKeys(Object(source), !0)).call(_context3, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context4 = ownKeys(Object(source))).call(_context4, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _parseInt from "@babel/runtime-corejs3/core-js-stable/parse-int";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";

/* eslint-disable indent */
import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Col from "orion/lib/col";
import Row from "orion/lib/row";
import Button from "orion/lib/button";
import FormModal from "../sharedComponent/formModal";
import { useAlertSchemas } from "../../contexts/alertSchemasContext";
import { useDruvaAlerts } from "../../contexts/DruvaAlertsContext";
import AlertTypeDetail from "../alertTypeDetails";
import { createAlertSubscription, toggleModalState, deleteAlertSubscription, updateAlertSubscription, fetchAdminList } from "../../actionCreators/alertsSettingActionCreators";

var SettingActions = function SettingActions(props) {
  var _context2;

  var deleteAlertSubscription = props.deleteAlertSubscription,
      createAlertSubscription = props.createAlertSubscription,
      updateAlertSubscription = props.updateAlertSubscription,
      fetchAdminList = props.fetchAdminList,
      toggleModalState = props.toggleModalState,
      selectedAlertsType = props.selectedAlertsType;

  var _useAlertSchemas = useAlertSchemas(),
      isModalOpen = _useAlertSchemas.isModalOpen,
      adminList = _useAlertSchemas.adminList,
      fetchingAdmins = _useAlertSchemas.fetchingAdmins;

  var _useDruvaAlerts = useDruvaAlerts(),
      allowedAdminRoles = _useDruvaAlerts.allowedAdminRoles,
      _useDruvaAlerts$apiCo = _useDruvaAlerts.apiConfig,
      alertsApiPath = _useDruvaAlerts$apiCo.alertsApiPath,
      listAdminsApiPath = _useDruvaAlerts$apiCo.listAdminsApiPath,
      accessTokenApiPath = _useDruvaAlerts$apiCo.accessTokenApiPath,
      alertsApiBaseUrl = _useDruvaAlerts$apiCo.alertsApiBaseUrl;

  var _ref = selectedAlertsType || {},
      id = _ref.id,
      subscription = _ref.subscription;

  var _ref2 = subscription || {},
      subscriptionType = _ref2.subscriptionType,
      notificationFrequency = _ref2.notificationFrequency,
      subscribers = _ref2.subscribers;

  var submitFormCallback = useCallback(function (values) {
    if (values.subscriptionType === "1" && values.subscribers.length === 0) {
      deleteAlertSubscription({
        subscription: {
          subscriptionID: subscription.subscriptionID
        },
        apiBaseUrl: alertsApiBaseUrl,
        apipathprefix: alertsApiPath,
        accessTokenApiPath: accessTokenApiPath
      });
    } else {
      var _context;

      var subscriberList = values.subscriptionType === "2" ? [] : _mapInstanceProperty(_context = values.subscribers).call(_context, function (s) {
        return {
          subscriberID: s.subscriberID,
          subscriberEmail: s.subscriberEmail
        };
      });

      if (!subscription) {
        createAlertSubscription({
          subscription: {
            subscriptionType: _parseInt(values.subscriptionType, 10),
            notificationFrequency: _parseInt(values.notificationFrequency, 10),
            alertTypeID: id,
            subscribers: subscriberList
          },
          apiBaseUrl: alertsApiBaseUrl,
          apipathprefix: alertsApiPath,
          accessTokenApiPath: accessTokenApiPath
        });
      } else {
        updateAlertSubscription({
          subscription: {
            subscriptionID: subscription.subscriptionID,
            subscriptionType: _parseInt(values.subscriptionType, 10),
            notificationFrequency: _parseInt(values.notificationFrequency, 10),
            subscribers: subscriberList
          },
          apiBaseUrl: alertsApiBaseUrl,
          apipathprefix: alertsApiPath,
          accessTokenApiPath: accessTokenApiPath
        });
      }
    }
  }, [id, subscription]);
  var onEditCallback = useCallback(function () {
    fetchAdminList({
      apiBaseUrl: alertsApiBaseUrl,
      apipathprefix: listAdminsApiPath,
      accessTokenApiPath: accessTokenApiPath,
      allowedAdminRoles: allowedAdminRoles
    });
    toggleModalState(!isModalOpen);
  }, [isModalOpen]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
    label: "Edit",
    onClick: onEditCallback,
    disabled: !selectedAlertsType
  }))), isModalOpen && /*#__PURE__*/React.createElement(FormModal, {
    withValidation: true,
    initialValues: {
      subscriptionType: subscriptionType ? subscriptionType.toString() : "",
      notificationFrequency: notificationFrequency ? notificationFrequency.toString() : "",
      subscribers: _mapInstanceProperty(_context2 = subscribers || []).call(_context2, function (s) {
        return _objectSpread(_objectSpread({}, s), {}, {
          label: s.subscriberEmail,
          value: s.subscriberEmail
        });
      })
    },
    header: "Edit Alert Settings",
    closeModal: function closeModal() {
      return toggleModalState(!isModalOpen);
    },
    cancelButtonLabel: "Cancel",
    submitButtonLabel: "Save",
    validationSchema: function validationSchema(Yup) {
      return Yup.object().shape({
        subscriptionType: Yup.string().required("This field is required."),
        notificationFrequency: Yup.string().required("This field is required."),
        subscribers: Yup.array().when("subscriptionType", function (type, schema) {
          return type === "1" ? schema.min(1, "Select at least one subscriber.") : schema.min(0);
        })
      });
    },
    onSubmit: submitFormCallback,
    size: "lg"
  }, /*#__PURE__*/React.createElement(AlertTypeDetail, {
    adminList: adminList,
    fetchingAdmins: fetchingAdmins,
    alertType: selectedAlertsType
  })));
};

SettingActions.propTypes = {
  selectedAlertsType: PropTypes.object
};
var mapDispatchToProps = {
  deleteAlertSubscription: deleteAlertSubscription,
  createAlertSubscription: createAlertSubscription,
  updateAlertSubscription: updateAlertSubscription,
  fetchAdminList: fetchAdminList,
  toggleModalState: toggleModalState
};
export default connect(null, mapDispatchToProps)(SettingActions);